<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  import BasePill, { type BasePillProps } from './BasePill.svelte';

  export type Variant = 'wording' | 'compositions' | 'warning' | 'info' | 'spelling' | 'grammar';

  export interface BrandFitResultProps {
    children: BasePillProps['children'];
    variant: Variant;
  }
</script>

<script lang="ts">
  let { ...props }: BrandFitResultProps = $props();

  const styles = tv({
    base: '',
    variants: {
      variant: {
        wording: 'bg-brandfit-wording',
        compositions: 'bg-brandfit-compositions',
        warning: 'bg-brandfit-warning',
        info: 'bg-brandfit-info',
        spelling: 'bg-brandfit-spelling',
        grammar: 'bg-brandfit-grammar',
      },
    },
  });
</script>

<BasePill class={styles({ variant: props.variant })}>{@render props.children()}</BasePill>
